import React, { useState, useEffect } from 'react';
import Modal from '../ui/Modal';
import useModal from '../../hooks/useModal'


const Bottomber = () => {
  const [currentPage, setCurrentPage] = useState("login");
  const { isOpen, openModal, closeModal } = useModal();
  const token = localStorage.getItem('token');
  

  const hundleClick = async() => {
    if(token){
      window.location.href = "/chat_list"
    }else{
      setCurrentPage("404-login");
      openModal();
    }
  }

  return (
    <>
    <div className='bottomber'>
      <div className='bottomber__item'>
        <a href='/sharehouse'>
        <img src="/media/house.svg" alt="シェアハウス掲示板" />
        <span>シェアハウス</span>
        </a>
      </div>     
      <div className='bottomber__item'>
        <a href='/job'><img src="/media/job.svg" alt="求人掲示板" />
        <span>求人情報</span>
        </a>
      </div>
      <div className='bottomber__item'>
        <a href='/transaction'><img src="/media/money.svg" alt="物品売買掲示板" />
      <span>物品売買</span>
      </a>
      </div>
      <div className='bottomber__item' onClick={hundleClick}>
        <img src="/media/group.svg" alt="チャットページ" />
        <span>メッセージ</span>
      </div>
    </div>
    <Modal 
    isOpen={isOpen} 
    closeModal={closeModal} 
    currentPage={currentPage} 
    setCurrentPage={setCurrentPage} 
    className="login"
    >
    </Modal>
    </>
  );
};

export default Bottomber;